import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { FutureDrawOption } from '../future-draws-dtos';

@Component({
  selector: 'app-future-draws-form-field',
  templateUrl: './future-draws-form-field.component.html',
  styleUrls: ['./future-draws-form-field.component.scss'],
  standalone: false,
})
export class FutureDrawsFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: FutureDrawOption[];

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public tableData: MatTableDataSource<any>;

  public displayedFieldsNames: string[];

  public fields: FieldConfigDTO[];

  ngOnInit() {
    if (!this.data) {
      this.data = [
        {
          numberOfDraws: 2,
        },
        {
          numberOfDraws: 4,
        },
        {
          numberOfDraws: 8,
        },
      ];
    }

    this.formGroup.get(this.fieldConfig.name).setValue(this.data);
    this.fields = [
      {
        name: 'numberOfDraws',
        label: 'Number of draws',
        type: DataType.number,
      },
      {
        name: 'untilDate',
        label: 'Until Date',
        type: DataType.date_time,
        editReadOnly: 'true',
        timezone: 'GMT',
      },
    ];

    this.displayedFieldsNames = this.fields.map((f) => f.name);
    this.tableData = new MatTableDataSource(this.data);
  }

  onValueChanged(value: any[] | any) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    formControl.setValue(value);
  }
}
